// 用户信息
// 用户列表
export const userregisterlist = "/zulin/pc/user/register/list"
// 用户详情
export const userregisterdetail = "/zulin/pc/user/register/detail?id="

// 用户行为轨迹
export const getUserBehaviorList = "/zulin/pc/user/trace/eventList"

// 新增行为名称
export const addBehaviorName = "/zulin/pc/user/trace/addName"

// 营业员行为轨迹
export const getSellerBehaviorList = "/zulin/pc/user/credit/order/trace/list"

// 登录记录
export const getLoginRecordList = "/zulin/pc/user/loginLog/list"

export const getUserGpsRecordList = "/zulin/pc/user/gpsLog/list"

export const getBlackUserList = "/zulin/pc/user/blacklist/list"

export const addBlackUser = "/zulin/pc/user/blacklist/save"

export const updateBlackUserStatus = "/zulin/pc/user/blacklist/modifyStatus"

export const getBlackUserElementList = "/zulin/pc/user/blacklist/element/list"

export const updateBlackElementStatus = "/zulin/pc/user/blacklist/element/modifyStatus"

export const deleteBlackElement = "/zulin/pc/user/blacklist/element/remove"

export const queryUserData = "/zulin/pc/user/search"

export const queryMerchantData = "/zulin/pc/user/merchant/preTest/list"

export const queryHallData = "/zulin/pc/user/shop/preTest/list"

export const querySellerData = "/zulin/pc/user/seller/preTest/list"

export const getEstimateList = "/zulin/pc/risk/adm/estimate/list"

export const riskEstimate = "/zulin/pc/risk/adm/estimate"

export const getEstimateDetail = "/zulin/pc/risk/adm/estimate/log/list?id="

export const updateUserStatus = "/zulin/pc/user/register/changeStatus"
